import { Observable } from 'rxjs';

import { SnLonLat } from '@lib/geo/helpers';

export abstract class FsMapDrawingServiceProvider {
  abstract readonly geospatialProvider: string;
  abstract readonly id: string;

  abstract get drawingMode(): string | null;
  // TODO: https://taserintl.atlassian.net/browse/FWX-3078
  // TODO: Add Google/Esri Union once Google Shell is implemented
  abstract get newShapeComplete$(): Observable<any>;
  abstract get shapeAction(): string | null;
  abstract get isDrawingAlertBoundary(): string | null;
  abstract onMapLoaded(fsMap: any): void;
  abstract addShape(type: string, action: string): void;
  abstract setIsDrawingAlertBoundary(isDrawingAlertBoundary: string | null): void;
  abstract setDrawingMode(overlayType?: any): void;
  abstract getDrawingMode(): any | undefined;
  abstract resetMapOptions(): void;
  abstract drawPolyline(coordinate1: SnLonLat, coordinate2: SnLonLat): void;
  abstract drawPolylines(coordinates: Array<{ position1: SnLonLat; position2: SnLonLat }>): void;
  abstract clearPolyline(): void;
  abstract clearPolylines(): void;
  abstract clearDrawing(shape: any): void;

  abstract pointInCircle(point: SnLonLat, radius: number, center: SnLonLat): boolean;
  abstract isPointInShape<T extends { lat: number; lon: number }>(marker: T, shape: any): boolean;
  abstract filterMarkersInShape<T extends { lat: number; lon: number }>(
    markers: T[],
    shape: any,
  ): T[];
  abstract removePenListeners(): void;
  abstract getDockedElementCoords(element: Element): { lng: number; lat: number } | undefined;
}
